import { ErrorHandler, Injectable } from '@angular/core';

// Global error handler for the application to resolve console errors.
@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
    override handleError(error: unknown): void {
        if (GlobalErrorHandler.isSuppressed(error)) {
            return;
        }
        super.handleError(error);
    }

    private static isSuppressed(error: unknown): boolean {
        const err = error as { errorMessage?: string; message?: string } | null;
        const message = err?.errorMessage ?? err?.message ?? String(error ?? '');
        // Expected B2C user cancellation of the edit-MFA prompt.
        if (message.includes('AADB2C90091')) {
            return true;
        }
        // Benign dev-only NG0100 from the library MenuComponent (kept narrow so our own NG0100s still surface).
        if (message.includes('NG0100') && message.includes('MenuComponent')) {
            return true;
        }
        return false;
    }
}

